/* NIGHT OPERATORS SHOP ALL, SHOP THE LOOK ON PHONES (lane SHOP-ALL-1022, 22 Oct 2026 night). NEW FILE.
   Loaded (defer) by sections/no-shop-all-look-m beside no-shop-all-r1-1022.js; runs once. Phones and narrow tablets only.
   1. Tiles: each part's app icon tile is placed near its dot, inside the picture with a margin, off the face box
      (section setting, fractions of the picture), off the other tiles and dots; a short line joins tile and dot.
      Dots use the same object-fit cover math as the r1 script. Recomputed on load, picture load and resize.
   2. Bottom card: a tap on a tile opens one card with a copy of that part's look card (picture, name, live price,
      stock, the same Add or See options button). Tap outside, the close button, Escape or a swipe down closes it.
      Focus moves into the card and back to the tile. An Add that lands closes the card so the cart drawer shows.
   No em or en dashes. */
(function () {
  if (window.__nsaLookM) return;
  window.__nsaLookM = true;
  var mq = window.matchMedia('(max-width: 989px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var NS = 'http://www.w3.org/2000/svg';
  var DIRS = { right: [1, 0], left: [-1, 0], up: [0, -1], down: [0, 1],
    'up-right': [0.7071, -0.7071], 'up-left': [-0.7071, -0.7071], 'down-right': [0.7071, 0.7071], 'down-left': [-0.7071, 0.7071] };
  var STEPS = [44, 54, 66, 80, 96, 114, 134];
  var MARGIN = 8, GAP = 6, DOT_R = 11;

  function geom(sec) {
    var stage = sec.querySelector('[data-nsa-stage]'), img = sec.querySelector('[data-nsa-look-img]');
    if (!stage || !img) return null;
    var nw = img.naturalWidth || Number(img.getAttribute('width')) || 1;
    var nh = img.naturalHeight || Number(img.getAttribute('height')) || 1;
    var fx = (Number(img.getAttribute('data-fx')) || 50) / 100;
    var sr = stage.getBoundingClientRect(), ir = img.getBoundingClientRect();
    var sc = Math.max(ir.width / nw, ir.height / nh), dw = nw * sc, dh = nh * sc;
    var box = { l: ir.left - sr.left, t: ir.top - sr.top, r: ir.right - sr.left, b: ir.bottom - sr.top };
    return { stage: stage, sr: sr, box: box, ox: box.l + (ir.width - dw) * fx, oy: box.t + (ir.height - dh) * 0.5, dw: dw, dh: dh };
  }
  function overlap(a, b) {
    var w = Math.min(a.r, b.r) - Math.max(a.l, b.l), h = Math.min(a.b, b.b) - Math.max(a.t, b.t);
    return w > 0 && h > 0 ? w * h : 0;
  }
  function circleHit(r, c, rad) {
    var x = Math.max(r.l, Math.min(c.x, r.r)), y = Math.max(r.t, Math.min(c.y, r.b));
    return Math.hypot(c.x - x, c.y - y) < rad;
  }

  /* 23 Oct: chips with a short title. Every part gets a list of allowed spots (inside the picture with the margin, off
     the face, off every dot, title on the side away from its dot, line not too long), then a beam search picks the set
     with the shortest lines where no two chips touch, no line crosses another line or another chip, and chips keep an
     even gap. Anything that cannot be met costs a large penalty instead of being dropped, and is written to data-score. */
  var CH_GAP = 4, SEP = 6, SEP_SOFT = 16, BEAM = 220, KEEP = 170, BAD = 100000;
  function segHit(ax, ay, bx, by, r) {
    var t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, p = [-dx, dx, -dy, dy], q = [ax - r.l, r.r - ax, ay - r.t, r.b - ay];
    for (var i = 0; i < 4; i++) {
      if (p[i] === 0) { if (q[i] < 0) return false; continue; }
      var u = q[i] / p[i];
      if (p[i] < 0) { if (u > t1) return false; if (u > t0) t0 = u; } else { if (u < t0) return false; if (u < t1) t1 = u; }
    }
    return t1 - t0 > 1e-6;
  }
  function segX(a, b) {
    function o(px, py, qx, qy, rx, ry) { return (qx - px) * (ry - py) - (qy - py) * (rx - px); }
    var d1 = o(b.x1, b.y1, b.x2, b.y2, a.x1, a.y1), d2 = o(b.x1, b.y1, b.x2, b.y2, a.x2, a.y2);
    var d3 = o(a.x1, a.y1, a.x2, a.y2, b.x1, b.y1), d4 = o(a.x1, a.y1, a.x2, a.y2, b.x2, b.y2);
    return ((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) && ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0));
  }
  function sep(a, b) { return Math.max(a.l - b.r, b.l - a.r, a.t - b.b, b.t - a.b); }
  function edgePt(ic, x, y) {
    var cx = (ic.l + ic.r) / 2, cy = (ic.t + ic.b) / 2, h = (ic.r - ic.l) / 2, vx = x - cx, vy = y - cy;
    var k = Math.min(vx ? h / Math.abs(vx) : Infinity, vy ? h / Math.abs(vy) : Infinity);
    return { x: cx + vx * k, y: cy + vy * k };
  }
  function placeChips(sec, tiles, g, box, face, dots, svg) {
    var parts = [];
    tiles.forEach(function (t) {
      var n = t.getAttribute('data-nsa-tile'), d = dots[n];
      t.style.left = ''; t.style.top = ''; t.classList.remove('is-l', 'is-r');
      if (!d || !d.on) { t.classList.remove('is-on'); return; }
      var ic = t.querySelector('.nsa-tile__ic'), lb = t.querySelector('.nsa-tile__t');
      var s = (ic && ic.offsetWidth) || 44, lw = lb ? lb.offsetWidth : 0, lh = lb ? lb.offsetHeight : 0;
      parts.push({ t: t, n: n, d: d, s: s, lw: lw, lh: lh, w: s + (lw ? CH_GAP + lw : 0) });
    });
    var maxLen = Math.max(150, Math.min(240, (box.r - box.l) * 0.36)), step = 6;
    parts.forEach(function (p) {
      var c = [], h = p.s / 2, R = maxLen + p.s, seen = {};
      var pref = p.t.getAttribute('data-dir'), pv = pref && DIRS[pref];
      /* a plain grid plus the exact spots flush with the picture edges and the face box, so a thin strip is never missed */
      function axis(lo, hi, extra) {
        var v = [], a;
        for (a = lo; a <= hi; a += step) v.push(a);
        extra.forEach(function (e) { if (e >= lo && e <= hi) v.push(e); });
        return v;
      }
      var ys = axis(Math.max(box.t, p.d.y - R), Math.min(box.b, p.d.y + R),
        [box.t + MARGIN + h, box.b - MARGIN - h].concat(face ? [face.t - 2 - h, face.b + 2 + h] : []));
      for (var oi = 0; oi < (p.lw ? 2 : 1); oi++) {
        var left = oi === 1;
        var xs = axis(Math.max(box.l, p.d.x - R), Math.min(box.r, p.d.x + R),
          left ? [box.l + MARGIN + p.w - h, box.r - MARGIN - h].concat(face ? [face.l - 2 - h, face.r + 2 + p.w - h] : [])
               : [box.l + MARGIN + h, box.r - MARGIN - p.w + h].concat(face ? [face.l - 2 - p.w + h, face.r + 2 + h] : []));
        for (var yi = 0; yi < ys.length; yi++) {
          var cy = ys[yi];
          for (var xi = 0; xi < xs.length; xi++) {
            var cx = xs[xi];
            var ic = { l: cx - h, t: cy - h, r: cx + h, b: cy + h };
            var ch = left ? { l: ic.r - p.w, t: ic.t, r: ic.r, b: ic.b } : { l: ic.l, t: ic.t, r: ic.l + p.w, b: ic.b };
            if (ch.l < box.l + MARGIN || ch.r > box.r - MARGIN || ch.t < box.t + MARGIN || ch.b > box.b - MARGIN) continue;
            if (p.lw && (left ? p.d.x < cx - h * 0.4 : p.d.x > cx + h * 0.4)) continue;
            if (face && sep(ch, face) < 2) continue;
            var lab = p.lw ? (left ? { l: ch.l, t: cy - p.lh / 2, r: ic.l - CH_GAP, b: cy + p.lh / 2 } : { l: ic.r + CH_GAP, t: cy - p.lh / 2, r: ch.r, b: cy + p.lh / 2 }) : null;
            var hit = false;
            for (var k in dots) { if (dots[k].on && circleHit({ l: ch.l - 3, t: ch.t - 3, r: ch.r + 3, b: ch.b + 3 }, dots[k], DOT_R)) { hit = true; break; } }
            if (hit) continue;
            var e = edgePt(ic, p.d.x, p.d.y), len = Math.hypot(p.d.x - e.x, p.d.y - e.y);
            if (len < 12 || len > maxLen) continue;
            var ln = { x1: p.d.x, y1: p.d.y, x2: e.x, y2: e.y };
            if (lab && segHit(ln.x1, ln.y1, ln.x2, ln.y2, lab)) continue;
            var cost = len;
            if (pv) cost += 40 * (1 - ((cx - p.d.x) * pv[0] + (cy - p.d.y) * pv[1]) / (Math.hypot(cx - p.d.x, cy - p.d.y) || 1));
            var key = Math.round(cx / 12) + ':' + Math.round(cy / 12) + ':' + oi;
            if (seen[key] && seen[key].cost <= cost) continue;
            seen[key] = { ch: ch, ic: ic, ln: ln, left: left, cost: cost, len: len };
          }
        }
      }
      for (var kk in seen) c.push(seen[kk]);
      c.sort(function (a, b) { return a.cost - b.cost; });
      p.cand = c.slice(0, KEEP);
      if (!p.cand.length) {
        /* no clean spot at all: fall back to the nearest spot inside the picture, marked bad */
        var cx0 = Math.min(Math.max(p.d.x + (p.d.x < (box.l + box.r) / 2 ? -1 : 1) * 60, box.l + MARGIN + h), box.r - MARGIN - h);
        var cy0 = Math.min(Math.max(p.d.y - 60, box.t + MARGIN + h), box.b - MARGIN - h);
        var ic0 = { l: cx0 - h, t: cy0 - h, r: cx0 + h, b: cy0 + h }, lf = cx0 > (box.l + box.r) / 2;
        var ch0 = lf ? { l: ic0.r - p.w, t: ic0.t, r: ic0.r, b: ic0.b } : { l: ic0.l, t: ic0.t, r: ic0.l + p.w, b: ic0.b };
        var e0 = edgePt(ic0, p.d.x, p.d.y);
        p.cand = [{ ch: ch0, ic: ic0, ln: { x1: p.d.x, y1: p.d.y, x2: e0.x, y2: e0.y }, left: lf, cost: BAD, len: 0 }];
      }
    });
    var order = parts.slice().sort(function (a, b) { return a.cand.length - b.cand.length; });
    var beam = [{ pick: [], cost: 0 }];
    order.forEach(function (p) {
      var next = [];
      beam.forEach(function (st) {
        p.cand.forEach(function (c) {
          var cost = st.cost + c.cost;
          for (var i = 0; i < st.pick.length; i++) {
            var o = st.pick[i], gsep = sep(c.ch, o.ch);
            if (gsep < SEP) cost += BAD;
            else if (gsep < SEP_SOFT) cost += (SEP_SOFT - gsep) * 4;
            if (segX(c.ln, o.ln)) cost += BAD;
            if (segHit(c.ln.x1, c.ln.y1, c.ln.x2, c.ln.y2, o.ch) || segHit(o.ln.x1, o.ln.y1, o.ln.x2, o.ln.y2, c.ch)) cost += BAD;
          }
          next.push({ pick: st.pick.concat([c]), cost: cost });
        });
      });
      next.sort(function (a, b) { return a.cost - b.cost; });
      beam = next.slice(0, BEAM);
    });
    var best = beam[0];
    if (svg) svg.setAttribute('viewBox', '0 0 ' + g.sr.width + ' ' + g.sr.height);
    order.forEach(function (p, i) {
      var c = best.pick[i], t = p.t;
      t.style.left = c.ch.l + 'px'; t.style.top = c.ch.t + 'px';
      t.classList.add(c.left ? 'is-l' : 'is-r', 'is-on');
      t.setAttribute('data-score', Math.round(best.cost >= BAD ? best.cost : 0));
      if (!svg) return;
      var len = Math.hypot(c.ln.x2 - c.ln.x1, c.ln.y2 - c.ln.y1);
      if (len > 9) {
        var sx = c.ln.x1 + (c.ln.x2 - c.ln.x1) / len * 7, sy = c.ln.y1 + (c.ln.y2 - c.ln.y1) / len * 7;
        var ln = document.createElementNS(NS, 'line');
        ln.setAttribute('x1', sx.toFixed(1)); ln.setAttribute('y1', sy.toFixed(1));
        ln.setAttribute('x2', c.ln.x2.toFixed(1)); ln.setAttribute('y2', c.ln.y2.toFixed(1));
        ln.setAttribute('data-for', p.n);
        svg.appendChild(ln);
      }
    });
  }

  function place(sec) {
    var tiles = Array.prototype.slice.call(sec.querySelectorAll('[data-nsa-tile]'));
    var svg = sec.querySelector('[data-nsa-leads]');
    if (svg) while (svg.firstChild) svg.removeChild(svg.firstChild);
    if (!mq.matches || !tiles.length) return;
    var g = geom(sec);
    if (!g) return;
    var box = g.box, face = null;
    var f = (g.stage.getAttribute('data-face') || '').split(',').map(parseFloat);
    if (f.length === 4 && f.every(function (v) { return !isNaN(v); })) {
      face = { l: g.ox + f[0] * g.dw, t: g.oy + f[1] * g.dh, r: g.ox + f[2] * g.dw, b: g.oy + f[3] * g.dh };
    }
    var faceCx = face ? (face.l + face.r) / 2 : (box.l + box.r) / 2;
    var dots = {};
    sec.querySelectorAll('[data-nsa-dot]').forEach(function (d) {
      var x = g.ox + parseFloat(d.getAttribute('data-x')) * g.dw, y = g.oy + parseFloat(d.getAttribute('data-y')) * g.dh;
      var inside = x >= box.l + 6 && x <= box.r - 6 && y >= box.t + 6 && y <= box.b - 6;
      dots[d.getAttribute('data-nsa-dot')] = { x: x, y: y, on: inside };
    });
    if (sec.querySelector('.nsa-tile--t')) { placeChips(sec, tiles, g, box, face, dots, svg); return; }
    var placed = [];
    if (svg) svg.setAttribute('viewBox', '0 0 ' + g.sr.width + ' ' + g.sr.height);
    tiles.forEach(function (t) {
      var n = t.getAttribute('data-nsa-tile'), d = dots[n];
      t.style.left = ''; t.style.top = '';
      if (!d || !d.on) { t.classList.remove('is-on'); return; }
      var s = t.offsetWidth || 44, h = s / 2;
      var away = d.x < faceCx ? 'left' : 'right', other = away === 'left' ? 'right' : 'left';
      var order = [away, 'up-' + away, 'down-' + away, 'up', 'down', 'up-' + other, 'down-' + other, other];
      var pref = t.getAttribute('data-dir');
      if (pref && DIRS[pref]) { order = [pref].concat(order.filter(function (o) { return o !== pref; })); }
      var best = null;
      for (var si = 0; si < STEPS.length && !(best && best.score === 0); si++) {
        for (var oi = 0; oi < order.length; oi++) {
          var v = DIRS[order[oi]], cx = d.x + v[0] * STEPS[si], cy = d.y + v[1] * STEPS[si];
          var r = { l: cx - h, t: cy - h, r: cx + h, b: cy + h }, score = 0;
          score += Math.max(0, box.l + MARGIN - r.l) + Math.max(0, r.r - (box.r - MARGIN)) + Math.max(0, box.t + MARGIN - r.t) + Math.max(0, r.b - (box.b - MARGIN));
          score *= 1000;
          if (face) score += overlap(r, face) * 10;
          var pad = { l: r.l - GAP, t: r.t - GAP, r: r.r + GAP, b: r.b + GAP };
          placed.forEach(function (p) { score += overlap(pad, p) * 20; });
          Object.keys(dots).forEach(function (k) { if (dots[k].on && circleHit(r, dots[k], DOT_R)) score += 50000; });
          var cost = score + si * 0.5 + oi * 0.01;
          if (!best || cost < best.cost) best = { cx: cx, cy: cy, r: r, score: score, cost: cost };
          if (score === 0) break;
        }
      }
      placed.push(best.r);
      t.style.left = best.cx + 'px'; t.style.top = best.cy + 'px';
      t.classList.add('is-on');
      t.setAttribute('data-score', Math.round(best.score));
      if (!svg) return;
      var vx = d.x - best.cx, vy = d.y - best.cy;
      var k = Math.min(vx ? h / Math.abs(vx) : Infinity, vy ? h / Math.abs(vy) : Infinity);
      var ex = best.cx + vx * k, ey = best.cy + vy * k, len = Math.hypot(d.x - ex, d.y - ey);
      if (len > 9) {
        var sx = d.x - (d.x - ex) / len * 7, sy = d.y - (d.y - ey) / len * 7;
        var ln = document.createElementNS(NS, 'line');
        ln.setAttribute('x1', sx.toFixed(1)); ln.setAttribute('y1', sy.toFixed(1));
        ln.setAttribute('x2', ex.toFixed(1)); ln.setAttribute('y2', ey.toFixed(1));
        ln.setAttribute('data-for', n);
        svg.appendChild(ln);
      }
    });
  }

  /* bottom card */
  var cur = null, drag = null;
  function focusables(el) {
    return Array.prototype.slice.call(el.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (x) { return x.offsetParent !== null; });
  }
  function close(back) {
    if (!cur) return;
    var c = cur; cur = null;
    c.sheet.classList.remove('is-open', 'is-drag');
    c.panel.style.transform = '';
    c.tile.setAttribute('aria-expanded', 'false');
    c.tile.classList.remove('is-open');
    if (c.dot) c.dot.classList.remove('is-open');
    if (c.watch) c.watch.disconnect();
    var done = function () { if (!c.sheet.classList.contains('is-open')) { c.sheet.hidden = true; c.body.innerHTML = ''; } };
    if (reduce.matches) done(); else setTimeout(done, 260);
    if (back) { try { c.tile.focus({ preventScroll: true }); } catch (e) { c.tile.focus(); } }
  }
  function open(sec, tile) {
    var sheet = sec.__nsaSheet;
    if (!sheet) return;
    if (cur && cur.tile === tile) { close(true); return; }
    if (cur) close(false);
    var n = tile.getAttribute('data-nsa-tile');
    var li = sec.querySelector('[data-nsa-lc="' + n + '"]');
    if (!li) return;
    var body = sheet.querySelector('[data-nsa-sheet-body]'), panel = sheet.querySelector('[data-nsa-sheet-panel]');
    body.innerHTML = '';
    var card = document.createElement('div');
    card.className = 'nsa-sc';
    Array.prototype.forEach.call(li.children, function (ch) {
      if (ch.classList.contains('nsa-lc__n')) return;
      card.appendChild(ch.cloneNode(true));
    });
    var nm = card.querySelector('.nsa-lc__name');
    if (nm) { nm.id = sheet.id + '-name'; panel.setAttribute('aria-labelledby', nm.id); }
    body.appendChild(card);
    sheet.hidden = false;
    var dot = sec.querySelector('[data-nsa-dot="' + n + '"]');
    cur = { sec: sec, tile: tile, sheet: sheet, panel: panel, body: body, dot: dot, watch: null };
    tile.setAttribute('aria-expanded', 'true');
    tile.classList.add('is-open');
    if (dot) dot.classList.add('is-open');
    var add = card.querySelector('[data-nsa-add]');
    if (add && 'MutationObserver' in window) {
      cur.watch = new MutationObserver(function () { if (add.classList.contains('is-done')) close(false); });
      cur.watch.observe(add, { attributes: true, attributeFilter: ['class'] });
    }
    void panel.offsetWidth;
    sheet.classList.add('is-open');
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
  }
  function initSheet(sec) {
    var sheet = sec.querySelector('[data-nsa-sheet]');
    if (!sheet) return;
    document.body.appendChild(sheet);
    sec.__nsaSheet = sheet;
    var panel = sheet.querySelector('[data-nsa-sheet-panel]');
    sheet.addEventListener('click', function (ev) {
      if (ev.target === sheet || ev.target.closest('[data-nsa-sheet-close]')) { ev.preventDefault(); close(true); }
    });
    panel.addEventListener('touchstart', function (ev) {
      if (!cur || ev.touches.length !== 1) return;
      drag = { y: ev.touches[0].clientY, dy: 0 };
      sheet.classList.add('is-drag');
    }, { passive: true });
    panel.addEventListener('touchmove', function (ev) {
      if (!drag) return;
      drag.dy = Math.max(0, ev.touches[0].clientY - drag.y);
      panel.style.transform = 'translateY(' + drag.dy + 'px)';
    }, { passive: true });
    function end() {
      if (!drag) return;
      var dy = drag.dy; drag = null;
      sheet.classList.remove('is-drag');
      panel.style.transform = '';
      if (dy > 70) close(true);
    }
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
  }
  document.addEventListener('keydown', function (ev) {
    if (!cur) return;
    if (ev.key === 'Escape') { ev.preventDefault(); close(true); return; }
    if (ev.key === 'Tab') {
      var f = focusables(cur.panel);
      if (!f.length) { ev.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (ev.shiftKey && (a === first || a === cur.panel)) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && (a === last || !cur.panel.contains(a))) { ev.preventDefault(); first.focus(); }
    }
  });

  function init() {
    var secs = Array.prototype.slice.call(document.querySelectorAll('.nsa-look--m'));
    if (!secs.length) return;
    function all() { secs.forEach(place); if (cur && !mq.matches) close(false); }
    secs.forEach(function (sec) {
      initSheet(sec);
      sec.addEventListener('click', function (ev) {
        var t = ev.target.closest && ev.target.closest('[data-nsa-tile]');
        if (!t || !sec.contains(t)) return;
        ev.preventDefault();
        open(sec, t);
      });
      var img = sec.querySelector('[data-nsa-look-img]');
      if (img && !img.complete) img.addEventListener('load', function () { place(sec); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { place(sec); }).observe(sec);
    });
    window.addEventListener('resize', all);
    if (mq.addEventListener) mq.addEventListener('change', all);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
    document.addEventListener('shopify:section:unload', function (ev) {
      secs.forEach(function (sec) { if (ev.target && ev.target.contains && ev.target.contains(sec) && sec.__nsaSheet) { if (cur && cur.sec === sec) close(false); sec.__nsaSheet.remove(); } });
    });
    window.__nsaPlaceTiles = all;
    all();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
